"use client";
import React, { useEffect, useRef, useState } from "react";
import { Button, Popover } from "antd";
import { debounce } from "lodash";
import Header from "@/components/Header";
import ScrollLazyLoadImage from "@/components/ScrollLazyLoadImage";
import LOGO from "@/assets/images/logo.png";
// import VIDEO_IMG from'./video_img.jpg'
import { usePostHog } from 'posthog-js/react';
import DownLoad from './Download'
import { detectDevice } from '@/utils'
import { Dialog } from 'antd-mobile'
import { MAC_DOWNLOAD, WIN_DOWNLOAD } from '@/config/constent';
import { RenderFooter } from "./RenderFooter"
import { recordClickType } from "@/apis/record";
import { clickTypeMapper } from '@/config/constent';

import "../App.scss";

const VIDEO_IMG = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/4.jpg'
// export const showAlert = (message: string) => {
//   eventBus.emit('alert-message-error', message)
// }
interface Props {
  userOtherInfo: any;
  payCountObj: any;
}

const Home: React.FC<Props> = (props: Props) => {
  const posthog = usePostHog();
  const isPc = detectDevice()

  const videoRef = useRef(null);
  // const MAC_DOWNLOAD =
  // "https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.0%28MacOS%29.zip";
  // const WIN_DOWNLOAD =
  //   "https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.0%28Windows%29.zip";
  const TEACH_URL =
    "https://mi8elatzm1x.feishu.cn/wiki/SfaxwB67JiEoHAkvpf1cVUfInVf?from=from_copylink";
  const macRef = useRef<HTMLAnchorElement | null>(null);
  const winRef = useRef<HTMLAnchorElement | null>(null);

  const searchParamsString = window.location.href.split('?')[1] || '';
  const searchParams = new URLSearchParams(searchParamsString);
  const source = searchParams.get('s'); // source 参数值
  const detail = searchParams.get('d'); // detail 参数值
  // console.log('source, detail', source, detail);
  const xiaohongshu_link = 'https://www.xiaohongshu.com/user/profile/63070886000000000f005dba';
  const bilibili_link = 'https://space.bilibili.com/3546687805065289'
  const douyin_link = 'https://v.douyin.com/JZSjiobaTis/%201@2.com'

  const handleMACDownload = debounce(() => {
    if (!isPc) {
      Dialog.alert({
        content: '请在电脑端打开！',
        onConfirm: () => {
          console.log('Confirmed')
        },
      })
      return
    }
    if (macRef.current) {
      macRef.current?.click();
      if (source && detail) {
        posthog?.capture('haohui_source_download', {
          source: source,
          detail: detail,
          type: 'mac'
        });
      }
      posthog?.capture('haohui_download', {
        type: 'mac',
        info: navigator?.userAgent
      });
    }
  }, 1000);

  const handleWINDownload = debounce(() => {
    if (!isPc) {
      Dialog.alert({
        content: '请在电脑端打开！',
        onConfirm: () => {
          console.log('Confirmed')
        },
      })
      return
    }
    if (winRef.current) {
      winRef.current?.click();
      if (source && detail) {
        posthog?.capture('haohui_source_download', {
          source: source,
          detail: detail,
          type: 'win'
        });
      }
      posthog?.capture('haohui_download', {
        type: 'win',
        info: navigator?.userAgent
      });

    }
  }, 1000);

  const handleTeach = () => {
    window.open(TEACH_URL);
  };

  // 设置访问源 与 到期时间 s source d detail t time
  useEffect(() => {
    if (source && detail) {
      const isSameDay = (date1, date2) => {
        return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate()
        );
      }

      const obj = window?.localStorage?.getItem('s_d_v');
      if (obj) {
        const array = obj?.split('_')
        if (Array.isArray(array) && array?.length === 3) {
          const oldSource = array[0];
          const oldDetail = array[1];
          const oldTime = parseInt(array[2]);
          const now = Date.now();
         
          if (oldSource !== source || oldDetail !== detail || !isSameDay(new Date(oldTime), new Date(now))) { 
            window?.localStorage?.setItem('s_d_v', `${source}_${detail}_${Date.now()}`);
            
            posthog?.capture('haohui_source_visit', {
              source: source,
              detail: detail,
            });
          }

        }
      } else {
        window?.localStorage?.setItem('s_d_v', `${source}_${detail}_${Date.now()}`);
        posthog?.capture('haohui_source_visit', {
          source: source,
          detail: detail,
        });
      }
    }
  }, [source, detail])

  useEffect(() => {
    // eventBus.on('alert-message-error' , (message) => {
    //   setAletObj({
    //     visible: true,
    //     message
    //   })
    // })
    // const timer = setTimeout(() => {
    //   document.querySelector('#video')?.play()
    // }, 100)
    // return () => {
    //   clearTimeout(timer)
    // }
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      const v = videoRef.current;
      if (v) {
        v.muted = true; // Safari 必须显式设置
        v.playsInline = true;
        v.loop = true;
        v.setAttribute("muted", "");       // 双保险
        v.setAttribute("playsinline", ""); // 双保险
        v.setAttribute("loop", ""); // 双保险
        v.play().catch(err => {
          console.log("Autoplay blocked:", err);
        });
      }
    })
    return () => {
      clearTimeout(timer)
    }
  }, []);

  return (
    <>
      <div className="home" style={isPc ? { minWidth: '1310px', overflowX: 'auto' } : {}}>
        <Header {...props} />
        {/* {
          alertObj?.visible 
            ? (
              <Alert style={{ zIndex: 20, marginTop: '16px' }} message={alertObj?.message} type="error" showIcon closable />
            )
            : null
        } */}
        <div className={isPc ? 'homeBox' : 'mobile-homeBox'}>
          {/* <div className="logo">
            <img
              style={{
                width: "180px",
                height: "110px",
                marginLeft: "-25px",
                marginBottom: "-20px",
              }}
              alt="cemeta.png"
              src="/logo/cemeta.png"
            />

          </div> */}
          <div className="home-content" style={isPc ? { marginTop: '200px' } : { marginTop: '8em' }}>CeMeta</div>
          <div className="home-title">森宇宙好绘AI电商设计工具</div>
          <div className="home-content" style={isPc ? { marginTop: '16px', marginBottom: '120px' } : { marginBottom: '4em' }}>一人一天一套详情页</div>

          <div className="homeBox-footer-button">
            <Button
              style={{ marginRight: "32px" }}
              onClick={handleMACDownload}
            >
              <img
                style={{ width: "26px", height: "26px", marginRight: "4px" }}
                alt=""
                aria-hidden="true"
                src="/logo/svg/mac.svg"
              />
              mac 版本下载
            </Button>
            <Button
              style={{ marginRight: "32px" }}
              onClick={handleWINDownload}
            >
              <img
                style={{ width: "26px", height: "26px", marginRight: "4px" }}
                alt=""
                aria-hidden="true"
                src="/logo/svg/windows.svg"
              />
              win 版本下载
            </Button>
          </div>
          <a
            ref={macRef}
            href={MAC_DOWNLOAD}
            style={{ visibility: "hidden" }}
          >
            {" "}
          </a>
          <a
            ref={winRef}
            href={WIN_DOWNLOAD}
            style={{ visibility: "hidden" }}
          >
            {" "}
          </a>
        </div>
        {
          !isPc
            ? null
            : <video ref={videoRef} id="video" className="video" style={{ height: '60%' }} autoPlay muted playsInline loop>
              <source src="https://shopping-cdn.cemeta.cn/common/homeVideo.mp4" type="video/mp4" />
            </video>
        }

        {/* 长图切片懒加载组件 */}
        <div className="scroll-image-container" style={isPc ? {} : { marginTop: '60vh' }}>
          <ScrollLazyLoadImage />
        </div>
      </div>
    </>
  );
};

export default Home;
